import { getExperiment } from '@eventbrite/statsig';
import {
    PostCheckoutMandatoryQuestionsInAppVariant,
    POST_CHECKOUT_MANDATORY_QUESTIONS_IN_ANDROID_APP,
} from '../../constants/statsig';

export const getPostCheckoutMandatoryQuestionsInAndroidApp =
    (): PostCheckoutMandatoryQuestionsInAppVariant =>
        getExperiment(
            POST_CHECKOUT_MANDATORY_QUESTIONS_IN_ANDROID_APP.experiment,
            POST_CHECKOUT_MANDATORY_QUESTIONS_IN_ANDROID_APP.param,
            POST_CHECKOUT_MANDATORY_QUESTIONS_IN_ANDROID_APP.defaultValue,
        );
